import React, { useEffect, useRef } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


function IdleTimeoutModal({ handleLogout }) {
  const inactivityTimeoutRef = useRef(null);

  useEffect(() => {
    const warningTimeout = setTimeout(() => {
      toast.warning("You have been inactive for 5 minutes. You will be logged out soon.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      handleLogout();
    }, 200000000); // 20 minutes of inactivity

    return () => clearTimeout(warningTimeout);
  }, [handleLogout]);

  useEffect(() => {
    function handleInactivityTimeout() {
      handleLogout();
    }

    function resetTimeout() {
      clearTimeout(inactivityTimeoutRef.current);
      inactivityTimeoutRef.current = setTimeout(handleInactivityTimeout, 1800000); // 30 minutes
    }

    resetTimeout();

    window.addEventListener("mousemove", resetTimeout);
    window.addEventListener("keypress", resetTimeout);

    return () => {
      window.removeEventListener("mousemove", resetTimeout);
      window.removeEventListener("keypress", resetTimeout);
      clearTimeout(inactivityTimeoutRef.current);
    };
  }, [handleLogout]);

  return null;
}

export default IdleTimeoutModal;
